import * as React from 'react';
import { Button } from '@/components/ui/Button';
import { SettingsHeader } from './SettingsHeader';
import clsx from 'clsx';

interface SettingsRowProps {
  icon: string;
  title: string;
  description: React.ReactNode;
  onModify?: () => void; // Changed to optional
}

export const SettingsRow: React.FC<SettingsRowProps> = ({ icon, title, description, onModify }) => (
  <div
    className={clsx(
      'relative flex w-full',
      // Mobile: Column Layout (Stack vertically)
      'flex-col items-start gap-6',
      // Desktop: Row Layout (Side by side)
      'md:flex-row md:items-center md:justify-between md:gap-6'
    )}
  >
    {/* Header Info (Icon + Text) */}
    <div className='min-w-0 flex-1'>
      <SettingsHeader icon={icon} title={title} description={description} />
    </div>

    {/* Action Button - Only rendered if handler provided */}
    {onModify && (
      <div
        className={clsx(
          'shrink-0',
          // Mobile: Full Width container
          'w-full',
          // Desktop: Auto Width container
          'md:w-auto'
        )}
      >
        <Button
          variant='settings-modify'
          className={clsx(
            'h-[36px]',
            // Mobile: Full Width button
            'w-full',
            // Desktop: Fixed Width button
            'md:w-[154px]'
          )}
          onClick={onModify}
        >
          Modify
        </Button>
      </div>
    )}
  </div>
);
